import Astronaut from "../assets/astro.png";
import workshop from "../assets/workshops-min.png";
import events from "../assets/events-min.png";
import Techtalk from "../assets/tech-talks-person.png";
import Guitar from "../assets/guitar.png";
import Bandslam from "../assets/band-label.png";
import bandBack from "../assets/band_slam_back.svg";
import Ticket from "../assets/Ticket.png";
import TicketMob from "../assets/TicketMobile.png";
import ScrollGif from "../assets/scroll_anim1.gif";
import nontech from "../assets/non-tech.png"
import Card from "./Card";
import Slider from "./Slider";
import Tilt from "react-parallax-tilt";
import Zoom from "react-reveal/Zoom";
import Fade from 'react-reveal/Fade';
import Loader from "./Loader";
import SwiperC from "./SwiperC";
import Drone from "../assets/Drone.gif";
import CountDownTimer from './CountDownTimer';
import Gaming from "./Gaming";
import Dashed from "./dash";
import expo from "../assets/expo.png";
import Slide from 'react-reveal/Slide';
import Sponsors from "./Sponsors";

const Landing = () => {

	return (
		<div>
			<div>
				<div className="w-full pt-24 top-0">
					<div className="h-content m-auto pt-28 w-3/4 smm:pt-10 sm:py-6 md:pt-8">
						<Tilt tiltMaxAngleX={4} tiltMaxAngleY={4} gyroscope={true}>
						<img src={Ticket} alt="Teckshetra Ticket" className="md:hidden" />
						<img
							src={TicketMob}
							alt="Teckshetra Ticket"
							className="hidden mx-auto md:block"
						/>
						</Tilt>
					</div>
					<img
						className="m-auto py-20 w-14 sm:hidden"
						src={ScrollGif}
						alt="scroll wheel"
					/>
					<Slider />
				</div>
			</div>
			

			<div className="mt-40 mb-20 z-10 smm:pt-10 md:px-1 md:pt-0 md:mt-0 lg:mt-32 xl:mt-40">
				<Zoom delay={400}>
					<h2 className="uppercase px-32 font-bold text-9xl smm:text-xl sm:text-2xl sm:px-1 sm:my-8 sm:h-fit md:flex md:text-center md:text-4xl md:h-36 md:mb-10 md:items-end md:justify-center lg:text-7xl xl:text-8xl">
						Biggest{" "}
						<span className="inline-block mx-2 px-2 rounded-sm bg-white text-black">
						Techfest
						</span>{" "}
						in Kochi!
					</h2>
				</Zoom>

				<div className="flex px-20 mx-44 my-20 smm:w-full sm:px-4 md:m-1 sm:mb-6 lg:mx-4 xl:mx-20">
					<img
						className="animate-[blob_5s_infinite] smm:w-32 sm:h-96"
						src={Astronaut}
						alt="Astronaut"
					/>
					<div className="flex flex-col justify-center">
						<h3 className="my-3 text-3xl font-bold px-10 smm:text-lg sm:px-2">About Us</h3>
						<p className="pb-10 text-2xl smm:text-sm px-10 sm:px-2 md:text-sm text-justify text-gray-500">
							Techkshetra 2022, the biennial competitions festival of Rajagiri School of Engineering and Technology,
							Kakkanad, Kerala is a treasure trove of a wide range of events that bring together students of all fields for a day like no other. A group of tech driven students started a fiesta in the beginning of a new century and called it Techkshetra which translates to "Temple of Technology".
						</p>
					</div>
				</div>

				<Sponsors />

				<Slider />

				<div class="center px-20 mt-16 mb-20 sm:px-2">
					<h2 class="center-text glitch is-glitching text-[80px] lg:text-6xl md:text-5xl sm:text-3xl" data-text="#INNOVATION101">#INNOVATION<span>101</span></h2>
					<div>
						<p className="text-center text-gray-500">
							Innovation is the ability to see change as an opportunity, not a threat. It is the ability to embrace new ideas, to let go of old assumptions, and to break free from habitual ways of thinking and acting. Technology is the engine of innovation, the tool that allows us to translate our ideas into reality and to create new products, services, and experiences that can improve our lives and the world around us.
						</p>
					</div>
				</div>

				<Dashed />
				<div>
					<h3 className="mt-14 px-20 mx-44 text-5xl font-bold uppercase smm:text-xl lg:mx-1 md:text-center sm:text-2xl">
						What's in store for you?
					</h3>
				</div>

				<Zoom>
				<div className="flex justify-between w-full px-52 py-20 smm:px-4 smm:py-1 lg:px-4 lg:flex-wrap lg:justify-center lg:py-6 xll:px-10">
					<Card
						title="Workshops"
						desc="Get first hand experience and learn from the best across a wide area of interests"
						image={workshop}
						routing="/workshop"
					/>
					<Card
						title="Technical"
						desc="Bring out the techie in you in Workshops, Tech Talks, Competitions and much more!"
						image={events}
						routing="/technical"
					/>
					<Card
						title="Non Technical"
						desc="Unleash your spirit in fun events & competitions and stand a chance to win exciting prices"
						image={nontech
						}
						routing="/nontechnical"
					/>
				</div>
				</Zoom>

			</div>
			
			<Fade bottom>
				<img className="mx-auto mt-12 mb-28 scale-110 lg:w-3/4" src={Drone} alt="Drone Footage"/>
			</Fade>
			<Dashed />
			<div className="flex flex-col mb-10 ">
				<Slide left>
					<div className="w-full border-y-2 py-4 border-gray-800 h-[400px] flex sm:relative sm:h-1/4">
						<div className="flex sm:flex-col">
							<img src={Techtalk} alt="TechTalk" className="h-auto"></img>
							<div className="flex flex-col mt-12 sm:items-start">
								<div className="tech-talks tech-talks-l pr-2 sm:w-5/6 sm:text-5xl sm:h-16">
									TECH TALKS
								</div>
								<p className="tech-p text-gray-500 text-justify sm:pr-6 text-2xl smm:text-md pt-2 sm:pl-2">
									This is your chance to learn about the latest and greatest in technology! Join us to hear experts in their fields discuss the latest developments in the world of tech. From artificial intelligence to cybersecurity, find what sparks your interest.
								</p>
							</div>
						</div>

					</div>
				</Slide>
				<Slide right>
					<div className="w-full border-y-2 py-4 border-gray-800 h-[400px] flex justify-end sm:h-1/4">
						<div className="flex flex-row-reverse sm:flex-col">
							<img src={expo} alt="TechTalk" className="h-auto"></img>
							<div className="flex flex-col mt-12 sm:items-end ">
								<div className="tech-talks tech-talks-r pl-2 sm:w-5/6 sm:text-5xl sm:h-16">
									EXPO
								</div>
								<p className="tech-p text-gray-500 text-justify sm:pl-6 text-2xl smm:text-md pt-2 sm:pr-2">
									Are you ready to showcase your innovative ideas and products at Techkshetra's Product Expo competition? Join us and be the next big thing in technology and design. Show off your creativity and impress judges with your unique creations.
								</p>
							</div>
						</div>

					</div>
				</Slide>
			</div>
			
			<Dashed />
			<Gaming />
			<Dashed />

			<div className="flex justify-center items-center">
				<Zoom>
					<img
						className=" py-20 md:w-full w-1/2 xll:w-2/3"
						src={bandBack}
						alt="BandSlam"
					/>
				</Zoom>
				<Zoom delay={200}>
					<img
						className="absolute px-80 w-5/6 sm:px-1 md:px-10 xl:px-40 xll:px-64"
						src={Bandslam}
						alt="BandSlam"
					/>
				</Zoom>
				<Zoom delay={400}>
					<img
						className="absolute h-1/2 lg:h-1/4 md:h-2/5"
						src={Guitar}
						alt="BandSlam"
					/>
				</Zoom>
			</div>

			<Fade bottom>
				<div className="my-20">
					<SwiperC />
				</div>
			</Fade>
			
			<div className="w-full h-80 mt-40 mb-12 flex justify-center md:mb-0 md:h-72 md:mt-32">
				<CountDownTimer />
			</div>
			
			<Slider />
			<Loader/>
		</div>
	);
};

export default Landing;
